export default __webpack_public_path__ + "static/media/cafeina.6f88f6fc.svg";